import React from 'react';
import PropTypes from 'prop-types';
import { InputCheckbox } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { useFormContext } from 'react-hook-form';
import { FullPetDetailsPropTypes, SelectedPet } from '../../../propTypes/petDetails';
import './petSelectCheckboxes.scss';

export const PetSelectCheckboxes = ({ petDetails, onSelect, selectedPets, isClaimVetDetails }) => {
  const formContext = useFormContext();
  return (
    <fieldset className="petSelect">
      <div className="petSelectCheckboxes">
        {petDetails?.map((petDetail) => {
          const { FullPolicyNumber, Name, PolicyNumber, DateOfBirth } = petDetail;
          const pets = selectedPets.find((pet) => pet.policyNumber === PolicyNumber && pet.selected);
          return (
            <InputCheckbox
              key={FullPolicyNumber}
              name={`petSelectCheckbox_${PolicyNumber}`}
              id={`petSelectCheckbox_${PolicyNumber}`}
              label={Name}
              customChangeHandler={(e) => onSelect(PolicyNumber, Name, DateOfBirth, e)}
              checked={pets?.selected || false}
              fieldFormContext={formContext}
              disabled={isClaimVetDetails}
            />
          );
        })}
      </div>
    </fieldset>
  );
};

PetSelectCheckboxes.propTypes = {
  petDetails: PropTypes.arrayOf(FullPetDetailsPropTypes),
  onSelect: PropTypes.func,
  selectedPets: PropTypes.arrayOf(SelectedPet),
  isClaimVetDetails: PropTypes.bool
};
